<p-blockUI [blocked]="enabled">
  <div class="lds-facebook">
    <div></div>
    <div></div>
    <div></div>
  </div>
</p-blockUI>
